import { render, staticRenderFns } from "./lazyblock_container_cards.vue?vue&type=template&id=0dae9800"
import script from "./lazyblock_container_cards.vue?vue&type=script&lang=js"
export * from "./lazyblock_container_cards.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_container_cards.vue?vue&type=style&index=0&id=0dae9800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports